import {FootTrafficItem} from '@/map/@types/foot-traffic';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {useVisibleZoomLevel} from '@/map/hooks';
import {FootTrafficTile} from '../../AnalysisLayer/FootTrafficTile/Tile';

interface IProps {
  map?: naver.maps.Map;
  items?: FootTrafficItem[];
}

export const FootTrafficTiles = ({map, items}: IProps) => {
  const isVisibleZoom = useVisibleZoomLevel(
    MAX_VISIBLE_ZOOM_METER.mobile_markers
  );

  if (!map || !items || !isVisibleZoom) {
    return null;
  }

  return (
    <>
      {items.map(
        (i, idx) =>
          !!i.tilePolygon && (
            <FootTrafficTile key={idx} map={map} item={i} isMobile />
          )
      )}
    </>
  );
};
